<template>
  <div class="bf-auth">
    <!-- Painel de marca -->
    <div class="bf-auth__brand">
      <div class="bf-auth__brand-inner">
        <img
          class="bf-auth__brand-logo"
          src="/img/brand/bindfy_logo_new_white.png"
          alt="Bindfy"
        />
        <h2>Defina uma nova senha.</h2>
        <p>
          Escolha uma senha forte para manter sua conta e suas integrações
          protegidas.
        </p>
      </div>
      <div class="bf-auth__blob bf-auth__blob--1"></div>
      <div class="bf-auth__blob bf-auth__blob--2"></div>
    </div>

    <!-- Formulario -->
    <div class="bf-auth__form-wrap">
      <div class="bf-auth__card">
        <img
          class="bf-auth__logo-mobile"
          src="/img/brand/bindfy_logo_new_purple.png"
          alt="Bindfy"
        />
        <h1 class="bf-auth__title">Redefinir senha</h1>
        <p class="bf-auth__desc">Digite e confirme sua nova senha</p>

        <form @submit.prevent="handleSubmit()">
          <div class="bf-field">
            <label>Nova senha</label>
            <TextInput
              :label="'Digite a sua nova senha'"
              :type="'password'"
              v-model="passwordResetForm.password"
              :error-messages="
                v$.password.$errors
                  ? v$.password.$errors[0]?.$message
                  : undefined
              "
            />
          </div>

          <div class="bf-field">
            <label>Confirme a nova senha</label>
            <TextInput
              :label="'Digite a sua nova senha novamente'"
              :type="'password'"
              v-model="passwordResetForm.confirmationPassword"
              :error-messages="
                v$.confirmationPassword.$errors
                  ? v$.confirmationPassword.$errors[0]?.$message
                  : undefined
              "
            />
          </div>

          <PrimaryButton :is-loading="isLoading" label="Redefinir senha" />

          <div class="bf-auth__signup">
            <router-link to="/autenticar/acessar" class="bf-link">
              ← Voltar para login
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { useRouter, useRoute } from "vue-router";

import { useVuelidate } from "@vuelidate/core";

import { useAuth } from "@/composables/useAuth";

import PrimaryButton from "@/components/Forms/BasicElements/Button/PrimaryButton.vue";

import TextInput from "@/components/Forms/BasicElements/Input/TextInput.vue";

export default defineComponent({
  name: "ResetPasswordPage",
  components: {
    TextInput,
    PrimaryButton,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const {
      passwordResetFormRules,
      passwordResetForm,
      passwordReset,
      isLoading,
    } = useAuth();

    const handleSubmit = async () => {
      try {
        const result = await v$.value.$validate();

        if (!result) return;

        const token = route.params.token as string;
        const response = await passwordReset(passwordResetForm, token);

        if (response) {
          router.push({ name: "SignInPage" }).then(() => {
            router.go(0);
          });
        }
      } catch (e) {
        console.error(e);
      }
    };

    const v$ = useVuelidate(passwordResetFormRules, passwordResetForm);

    return {
      passwordResetForm,
      isLoading,
      handleSubmit,
      v$,
    };
  },
});
</script>
